<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <Sidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <section id="description">
        <div class="row">
          <div class="col-md-12">
            <div class="card custom-card">
              <form ref="updateForm" @submit.prevent="updateJobAd">
                <div class="job-content">
                  <div class="d-none d-sm-block">
                    <div class="col-md-12">
                      <div class="header-title d-flex">
                        <div
                          class="header-title-name d-flex align-items-center"
                          v-if="!isInGlobalEditMode"
                        >
                          <b>{{ marketingJob.job_title }}</b>
                          <span class="job-edit ml-2">
                            <router-link to>
                              <svgHelper
                                @click.native="changeGlobalEditMode"
                                class="job-edit-icon"
                                name="edit"
                              />
                            </router-link>
                          </span>

                          <div class="ms-auto mr-4">
                            <popper
                              trigger="hover"
                              :options="{
                                placement: 'left',
                                modifiers: { offset: { offset: '0,10px' } },
                              }"
                            >
                              <div style="font-size: 14px;" class="popper">
                                {{ !marketingJob.checked_by ? 'Check job' : 'Uncheck job' }}
                              </div>
                              <div slot="reference">
                                <i
                                  @click="
                                    setJobForCheck(
                                      marketingJob.mm_job_id,
                                      !marketingJob.checked_by ? true : false,
                                    )
                                  "
                                  type="button"
                                  data-toggle="modal"
                                  href="#addUserModalUserManagment"
                                  style="font-size: 21px; color: #999;"
                                  class="fas fa-check"
                                  :style="marketingJob.checked_by ? 'color: #ff741e ' : ''"
                                ></i>
                              </div>
                            </popper>
                          </div>
                        </div>

                        <div class="d-flex flex-grow-1 name-edit" v-else>
                          <input
                            type="text"
                            class="form-control"
                            id="job_name"
                            placeholder="Title"
                            v-model="marketingJobEdit.job_title"
                          />

                          <!-- Btns -->
                          <div
                            class="form-buttons text-right ml-auto w-50"
                            v-show="isInGlobalEditMode"
                          >
                            <button type="submit" class="btn btn-primary mr-2">Save</button>
                            <button class="btn btn-danger" @click="isInGlobalEditMode = false">
                              Cancel
                            </button>
                            <br />
                            <i
                              style="cursor: pointer; font-size: 21px"
                              data-toggle="modal"
                              href="#deleteJobModal"
                              class="fas fa-trash-alt mt-2"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <nav class="job-controls-tabs">
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-primary-tab"
                        data-toggle="tab"
                        href="#nav-primary"
                        role="tab"
                        aria-controls="nav-primary"
                        aria-selected="true"
                        ><i class="far fa-credit-card d-block d-sm-none"></i> PRIMARY</a
                      >

                      <a
                        class="nav-item nav-link"
                        id="nav-ad-tab"
                        data-toggle="tab"
                        href="#nav-ad"
                        role="tab"
                        aria-controls="nav-ad"
                        aria-selected="false"
                        ><i class="far fa-file-alt d-block d-sm-none"></i> DESCRIPTION</a
                      >
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="nav-primary"
                      role="tabpanel"
                      aria-labelledby="nav-primary-tab"
                    >
                      <div class="mobile-clear">
                        <div class="row">
                          <div class="col-md-12">
                            <ul class="list-group list-group-flush job-details">
                              <div class="row">
                                <li class="list-group-item col-md-6" style="padding-right: 0">
                                  <div
                                    v-if="!editIconState.employerFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.employer = true"
                                    @mouseleave="editFields.employer = false"
                                    class="d-flex"
                                  >
                                    <span>Employer</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.employer" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="employer"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <router-link
                                        class="username"
                                        :to="{
                                          name: 'employer_marketing_id',
                                          params: { employer_id: marketingJob.mm_employer_id },
                                        }"
                                        >{{ marketingJob.mm_employer_name }}</router-link
                                      >
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Employer</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      id="employer"
                                      placeholder="Employer"
                                      :value="marketingJobEdit.mm_employer_name"
                                      disabled
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.employerFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.cityFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.city = true"
                                    @mouseleave="editFields.city = false"
                                    class="d-flex"
                                  >
                                    <span>Location</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.city" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="city"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div>
                                        {{ marketingJob.city ? `${marketingJob.city}, ` : '' }}
                                        {{ marketingJob.country }}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex new-location" v-else>
                                    <span class="mr-0">
                                      <b>Location</b>
                                    </span>
                                    <div class="location-container">
                                      <v-select
                                        class="country-select mr-1"
                                        v-model="marketingJobEdit.country"
                                        @input="
                                          fetchCitiesByCountryId($event);
                                          clearCity();
                                        "
                                        label="name"
                                        :options="getAllCountries"
                                        :reduce="country => country"
                                        :clearable="false"
                                      >
                                        <template v-slot:no-options="{ search, searching }">
                                          <template v-if="searching && search.length >= 3">
                                            No results found for <em>{{ search }}</em
                                            >.
                                          </template>
                                          <div style="opacity: 0.5" v-else>
                                            Please type at least 3 characters
                                          </div>
                                        </template>
                                      </v-select>
                                      <v-select
                                        class="city-select"
                                        label="name"
                                        v-model="marketingJobEdit.city"
                                        :options="getCitiesListByCountry"
                                        :reduce="city => city"
                                        :clearable="false"
                                      >
                                        <template v-slot:no-options>
                                          <div style="opacity: 0.5">
                                            Please select a country first
                                          </div>
                                        </template>
                                      </v-select>
                                    </div>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.cityFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.countryFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.country = true"
                                    @mouseleave="editFields.country = false"
                                    class="d-flex"
                                  >
                                    <span>Office</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.country" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="country"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div>
                                        {{ marketingJob.office ? marketingJob.office : 'N/A' }}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex new-location" v-else>
                                    <span class="mr-0">
                                      <b>Office</b>
                                    </span>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="employer"
                                      placeholder="Office"
                                      v-model="marketingJobEdit.office"
                                    />
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.countryFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.postalFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.postal = true"
                                    @mouseleave="editFields.postal = false"
                                    class="d-flex"
                                  >
                                    <span>Postal code</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.postal" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="postal"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{
                                        marketingJob.postal_code ? marketingJob.postal_code : 'N/A'
                                      }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Postal code</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Postal code"
                                      v-model="marketingJobEdit.postal_code"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.postalFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.workplaceFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.workplace = true"
                                    @mouseleave="editFields.workplace = false"
                                    class="d-flex"
                                  >
                                    <span>Workplace</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.workplace" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="workplace"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ showWorkPlace(marketingJob.workplace) }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Workplace</span>
                                    <select
                                      class="form-control w-100"
                                      v-model="marketingJobEdit.workplace"
                                      style="box-shadow: none"
                                    >
                                      <option value="1">Onsite</option>
                                      <option value="2">Hybrid</option>
                                      <option value="3">Remote</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.workplaceFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.fullTimeFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.fullTime = true"
                                    @mouseleave="editFields.fullTime = false"
                                    class="d-flex"
                                  >
                                    <span>Full-time</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.fullTime" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="fullTime"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ marketingJob.full_time ? 'Yes' : 'No' }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Full time</span>

                                    <select
                                      class="form-control w-100"
                                      v-model="marketingJobEdit.full_time"
                                      style="box-shadow: none"
                                    >
                                      <option :value="true">Yes</option>
                                      <option :value="false">No</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.fullTimeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.streetFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.street = true"
                                    @mouseleave="editFields.street = false"
                                    class="d-flex"
                                  >
                                    <span>Salary</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.street" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="street"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{
                                        marketingJob.salary
                                          ? `${marketingJob.salary} ${marketingJob.salary_currency}`
                                          : 'N/A'
                                      }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Salary</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Salary"
                                      v-model="marketingJobEdit.salary"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.streetFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.individualsFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.individuals = true"
                                    @mouseleave="editFields.individuals = false"
                                    class="d-flex"
                                  >
                                    <span>URL</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.individuals" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="need-individuals"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <a :href="marketingJob.url" rel="nofollow" target="_blank">{{
                                        marketingJob.url
                                      }}</a>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>URL</span>

                                    <input
                                      type="text"
                                      class="form-control w-100"
                                      placeholder="URL"
                                      v-model="marketingJobEdit.url"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.individualsFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.employmentFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.employment = true"
                                    @mouseleave="editFields.employment = false"
                                    class="d-flex"
                                  >
                                    <span>Source URL</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.employment" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="employment"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <a
                                        :href="marketingJob.source_url"
                                        rel="nofollow"
                                        target="_blank"
                                        >{{
                                          marketingJob.source_url ? marketingJob.source_url : 'N/A'
                                        }}</a
                                      >
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Source URL</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control w-100"
                                      placeholder="Source URL"
                                      v-model="marketingJobEdit.source_url"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.employmentFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.durationFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.duration = true"
                                    @mouseleave="editFields.duration = false"
                                    class="d-flex"
                                  >
                                    <span>Posted Date</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <!--          <div class="edit-btn">
                                        <router-link v-if="editFields.duration" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="duration"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div> -->
                                      {{
                                        marketingJob.posted_date
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Posted Date</span>

                                    {{
                                      marketingJob.posted_date
                                        | formatDate({
                                          format: getUserProfile.format_date,
                                          timezone: getUserProfile.timezone,
                                          hasHourAndMinutes: false,
                                        })
                                    }}

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.durationFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.relocationFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.relocation = true"
                                    @mouseleave="editFields.relocation = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Discovered date</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <!--      <div class="edit-btn">
                                        <router-link v-if="editFields.relocation" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="relocation"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div> -->
                                      <span style="font-weight: 400">{{
                                        marketingJob.discovered_date
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}</span>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      Discovered date
                                    </span>

                                    <span style="font-weight: 400">{{
                                      marketingJob.discovered_date
                                        | formatDate({
                                          format: getUserProfile.format_date,
                                          timezone: getUserProfile.timezone,
                                          hasHourAndMinutes: false,
                                        })
                                    }}</span>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.relocationFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap;">
                                  <div
                                    v-if="
                                      !editIconState.recruitingFeeFormShow && !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.recruitingFee = true"
                                    @mouseleave="editFields.recruitingFee = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Checked date</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <!--          <div class="edit-btn">
                                        <router-link v-if="editFields.recruitingFee" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="rFee"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div> -->
                                      <span
                                        v-if="jobAdData.recruiting_fee"
                                        style="font-weight: 400"
                                        >{{
                                          marketingJob.checked_date
                                            | formatDate({
                                              format: getUserProfile.format_date,
                                              timezone: getUserProfile.timezone,
                                              hasHourAndMinutes: false,
                                            })
                                        }}</span
                                      >
                                    </div>
                                  </div>
                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Checked date</b>
                                    </span>
                                    <span v-if="jobAdData.recruiting_fee" style="font-weight: 400">{{
                                      marketingJob.checked_date
                                        | formatDate({
                                          format: getUserProfile.format_date,
                                          timezone: getUserProfile.timezone,
                                          hasHourAndMinutes: false,
                                        })
                                    }}</span>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.recruitingFeeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap;">
                                  <div
                                    v-if="!editIconState.startingFeeFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.startingFee = true"
                                    @mouseleave="editFields.startingFee = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Checked by</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <!--     <div class="edit-btn">
                                        <router-link v-if="editFields.startingFee" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="stFee"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div> -->
                                      <span
                                        v-if="jobAdData.starting_fee"
                                        style="font-weight: 400"
                                        >{{ marketingJob.checked_by }}</span
                                      >
                                    </div>
                                  </div>
                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Checked by</b>
                                    </span>

                                    <span v-if="jobAdData.starting_fee" style="font-weight: 400">{{
                                      marketingJob.checked_by
                                    }}</span>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.startingFeeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.createdByFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.createdBy = true"
                                    @mouseleave="editFields.createdBy = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Created by</b>
                                    </span>

                                    <div class="custom-control icon-container">
                                      <!--      <div class="edit-btn">
                                        <router-link v-if="editFields.createdBy" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="created-by"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div> -->
                                      {{ marketingJob.created_by }}
                                    </div>
                                  </div>

                                  <span class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Created by</b>
                                    </span>

                                    {{ marketingJob.created_by }}
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.createdByFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </span>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap;">
                                  <div
                                    v-if="!editIconState.currencyFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.currency = true"
                                    @mouseleave="editFields.currency = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Created date</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <!--    <div class="edit-btn">
                                        <router-link v-if="editFields.currency" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="currency"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div> -->
                                      <span style="font-weight: 400">
                                        {{
                                          marketingJob.created_at
                                            | formatDate({
                                              format: getUserProfile.format_date,
                                              timezone: getUserProfile.timezone,
                                              hasHourAndMinutes: false,
                                            })
                                        }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Created date</b>
                                    </span>

                                    <span style="font-weight: 400">
                                      {{
                                        marketingJob.created_at
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </span>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.currencyFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                              </div>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="nav-ad"
                      role="tabpanel"
                      aria-labelledby="nav-ad-tab"
                    >
                      <div class="description-text col-md-12 mt-5 mx-auto">
                        <div class="d-flex">
                          <h6>Description</h6>
                          <div class="ml-auto buttons mb-2">
                            <div v-if="!editText" class="edit-btn">
                              <router-link to>
                                <i
                                  @click="onEditText(jobAdData.description)"
                                  id="lastUpdated"
                                  class="fas fa-pen edit-icon"
                                  style="color: #666"
                                ></i>
                              </router-link>
                            </div>

                            <div v-else>
                              <button type="submit" class="btn btn-outline btn-sm border mr-1">
                                <i style="color: green" class="fas fa-check"></i>
                              </button>
                              <CandidateEditFieldCancelBtn @clicked="editText = false">
                                <i class="fas fa-times" style="color: red"></i>
                              </CandidateEditFieldCancelBtn>
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="!editText"
                          class="description-text-body description-scroll col-md-7"
                          v-html="marketingJob.description"
                        ></div>

                        <div v-show="editText" class="text-editor">
                          <Editor v-model="marketingJob.description" />
                        </div>

                        <div
                          class="description-text-body description-scroll"
                          v-if="
                            !editIconState.descriptionFormShow && !isInGlobalEditMode && !editText
                          "
                          v-html="jobAdData.description"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>

      <section class="mt-4 mb-4" id="description">
        <div class="row">
          <div class="col-md-12">
            <div class="card custom-card">
              <div class="header-contacts">
                <h6 style="font-weight: 700">Recruiters</h6>
              </div>
              <table class="table table-striped custom-table">
                <thead class="bg-dark">
                  <tr>
                    <th nowrap scope="col">Name</th>
                    <th nowrap scope="col">Title</th>
                    <th nowrap scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(contact, index) in recruiters" :key="index">
                    <td nowrap scope="col">{{ contact.name }}</td>
                    <td scope="col">{{ contact.title }}</td>
                    <td v-if="contact.linkedin">
                      <a rel="nofollow" target="_blank" :href="contact.linkedin">
                        <div
                          style="width: 26px; height: 26px; fill: #0a66c2;"
                          v-html="linkedinIcon"
                        ></div
                      ></a>
                    </td>
                    <td v-else>
                      N/A
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>
      <!-- End Delete Job Modal -->
    </div>
    <!-- End page-content-wrapper -->
    <div
      class="modal fade add-user-modal"
      id="addUserModalUserManagment"
      tabindex="-1"
      aria-labelledby="addUserModalUserManagment"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalUserManagment">
              {{ check.status != true ? 'Uncheck Job' : 'Check Job' }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeUser"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 20px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <p>
                  {{
                    check.status != true
                      ? 'Please confirm that you want to mark the Job as unchecked.'
                      : 'Please confirm that you want to mark the Job as checked.'
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              @click="checkJob(check.jobId, check.status)"
              type="button"
              class="btn btn-primary"
            >
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade edit-modal"
      id="deleteJobModal"
      tabindex="-1"
      aria-labelledby="deleteJobModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteJobModal">Delete Job</h5>
            <button
              ref="closeModalBtn"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>
              Please confirm that you want to delete the Job.
            </p>
          </div>

          <div class="modal-footer text-center justify-content-center">
            <button @click="removeJob" type="button" class="btn btn-primary">Delete</button>

            <button
              ref="closeModalBtn"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { toggleSidebarNav } from '../../../mixins/toggleSidebarNav';
import Editor from '@/components/common/TextEditor';
import Sidebar from '../../Navigations/Sidebar';
import TopNavbar from '../../Navigations/TopNavbar';

import CustomMainModal from '../../Modals/CustomMainModal';

import CandidateEditFieldCancelBtn from '../common/CandidateEditFieldCancelBtn';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

// Activities AND EMAILS
import Activities from '../common/Activities';
/* import Emails from '../common/Emails'; */

/* import JobItemRequirements from '../Jobs/JobItemRequirements'; */
import Comments from '../common/Comments';

// Icons
import IconMapper from '../../common/iconMapper';

// PIPELINE
import JobItemPipeline from '../Jobs/JobItemPipeline';
import { degreeMixin } from '../../../mixins/degreeMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { errorService } from '../../../services/errorService';
import { MESSAGES, LOCATION } from '../../../constants';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';
import moment from 'moment-timezone';
// import moment from 'moment';

export default {
  components: {
    DatePicker,
    Editor,
    IconMapper,
    Sidebar,
    TopNavbar,
    Activities,
    CandidateEditFieldCancelBtn,
    /*  Emails, */
    JobItemPipeline,
    /*  JobItemRequirements, */
    Comments,

    /* IconMapper, */
  },
  mixins: [
    toggleSidebarNav,
    degreeMixin,
    stagesMixin,
    employmentMixin,
    jobStatusMixin,
    serviceLevelMixin,
    titleMixin,
  ],
  title() {
    return 'Job | Jobshark';
  },
  data: () => ({
    isPublishing: false,
    currencies: [],
    isSaving: false,
    locationsData: LOCATION,
    editText: false,
    selectedAvatar: null,
    selectedId: '',
    currentActivities: [],
    currentPage: 1,
    pageCount: 10,
    last_page: '',
    editFields: {
      currency: false,
      devskiller: false,
      workplace: false,
      summaryField: false,
      employer: false,
      city: false,
      country: false,
      street: false,
      employment: false,
      advertisingStartDate: false,
      approvalDate: false,
      advertisingEndDate: false,
      promoted: false,
      createdBy: false,
      createdAt: false,
      lastUpdated: false,
      yearsOfExperiance: false,
      degree: false,
      degreeField: false,
      competencesRequired: false,
      competencesAdvantage: false,
      languages: false,
      postal: false,
      relocation: false,
      descriptions: false,
      individuals: false,
      fullTime: false,
      duration: false,
      anon: false,
      startingFee: false,
      recruitingFee: false,
      programmingTestFee: false,
    },
    editIconState: {
      currencyFormShow: false,
      startingFeeFormShow: false,
      recruitingFeeFormShow: false,
      proggramingTestFormShow: false,
      devskillerFormShow: false,
      anonFormShow: false,
      workplaceFormShow: false,
      summaryFormShow: false,
      individualsFormShow: false,
      fullTimeFormShow: false,
      durationFormShow: false,
      employerFormShow: false,
      cityFormShow: false,
      countryFormShow: false,
      streetFormShow: false,
      employmentFormShow: false,
      advertisingStartDateFormShow: false,
      approvalDateFormShow: false,
      advertisingEndDateFormShow: false,
      promotedFormShow: false,
      createdByFormShow: false,
      createdAtFormShow: false,
      lastUpdatedFormShow: false,
      yearsOfExperianceFormShow: false,
      degreeFormShow: false,
      degreeFieldFormShow: false,
      competencesRequiredFormShow: false,
      competencesAdvantageFormShow: false,
      languagesFormShow: false,
      postalFormShow: false,
      relocationFormShow: false,
      descriptionFormShow: false,
    },
    jobStatusModalShow: false,
    jobSourcingModalShow: false,
    jobStatusOptions: [
      { value: 0, label: 'Active' },
      { value: 1, label: 'Submitted' },
      { value: 2, label: 'Approved' },
      { value: 3, label: 'Published' },
      { value: 4, label: 'Rejected' },
      { value: 5, label: 'Closed' },
    ],
    key: 0,
    showModal: false,
    isToggled: false,
    isLoading: false,
    isInGlobalEditMode: false,
    actualJobStatus: 0,
    actualServiceLevel: '',
    competencesAdv: [],
    competences: [],
    selectedCity: {},
    selectedCurrency: {},
    selectedJobStatus: 0,
    selectedCountry: '',
    selectedServiceLevel: 1,
    selectedJobTitle: '',
    selectedYearsExperience: '',
    selectedDegreeType: 0,
    selectedDegreeField: '',
    selectedCompetences: [],
    selectedCompetencesAdvantage: [],
    selectedEmploymentType: 1,
    selectedLanguages: [],
    selectedRelocation: false,
    selectedPostalCode: '',
    selectedPromoted: false,
    selectedAddress: '',
    selectedEndDate: '',
    selectedDescription: '',
    selectedIndividuals: 0,
    selectedFullTime: true,
    selectedDuration: '',
    selectedSummary: '',
    selectedWorkplace: '',
    selectedStartingFee: '',
    selectedRecruitingFee: '',
    selectedProgrammingTestFee: '',
    selectedTest: {
      name: '',
      id: '',
    },
    selectedTestId: '',
    dateOne: '',
    selectedAnon: false,
    jobAdData: {},
    plats_advertising: {
      published: false,
      title: '',
      professionId: '',
      startDate: null,
      endDate: null,
      tracking: '',
      link: '',
      manu: '',
      platsbanken_id: '',
      editLink: false,
    },
    allProfessions: [],
    professionId: '',
    professionName: '',
    DevSkillerTests: [],
    marketingJob: {
      mm_job_id: '',
      mm_employer_id: '',
      mm_employer_name: '',
      their_stack_job_id: '',
      job_title: '',
      office: '',
      postal_code: '',
      country: '',
      city: '',
      salary: '',
      salary_currency: '',
      linkedin: '',
      full_time: '',
      workplace: '',
      description: '',
      source: '',
      url: '',
      source_url: '',
      created_by: '',
      checked_by: '',
      hiring_team: [
        {
          name: '',
          title: '',
          linkedin: '',
        },
      ],
      posted_date: '',
      discovered_date: '',
      checked_date: '',
      created_at: '',
    },
    marketingJobEdit: {
      mm_job_id: '',
      mm_employer_id: '',
      mm_employer_name: '',
      their_stack_job_id: '',
      job_title: '',
      office: '',
      postal_code: '',
      country: '',
      city: '',
      salary: '',
      salary_currency: '',
      linkedin: '',
      full_time: '',
      workplace: '',
      description: '',
      source: '',
      url: '',
      source_url: '',
      created_by: '',
      checked_by: '',
      hiring_team: [
        {
          name: '',
          title: '',
          linkedin: '',
        },
      ],
      posted_date: '',
      discovered_date: '',
      checked_date: '',
      created_at: '',
    },
    check: {
      status: true,
      jobId: '',
    },
    recruiters: [],
    linkedinIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M512 96L127.9 96C110.3 96 96 110.5 96 128.3L96 511.7C96 529.5 110.3 544 127.9 544L512 544C529.6 544 544 529.5 544 511.7L544 128.3C544 110.5 529.6 96 512 96zM231.4 480L165 480L165 266.2L231.5 266.2L231.5 480L231.4 480zM198.2 160C219.5 160 236.7 177.2 236.7 198.5C236.7 219.8 219.5 237 198.2 237C176.9 237 159.7 219.8 159.7 198.5C159.7 177.2 176.9 160 198.2 160zM480.3 480L413.9 480L413.9 376C413.9 351.2 413.4 319.3 379.4 319.3C344.8 319.3 339.5 346.3 339.5 374.2L339.5 480L273.1 480L273.1 266.2L336.8 266.2L336.8 295.4L337.7 295.4C346.6 278.6 368.3 260.9 400.6 260.9C467.8 260.9 480.3 305.2 480.3 362.8L480.3 480z"/></svg>`,
  }),
  methods: {
    ...mapActions([
      'setJobStatus',
      'updateJobAdById',
      'retrieveJobAdById',
      'retrieveUserProfile',
      'retrieveJobActivities',
      'retrieveJobAdCommentsList',
      'retrieveCitiesListByCountryId',
      'retrieveActivitiesForJob',
      'retrieveCompetencesList',
      'retrieveJobComments',
      'addJobAdComment',
      'editJobAdComment',
      'removeJobAdComment',
      'sendManagerRecent',
      'retrieveEmployersDropdown',
      'retrieveSourcesList',
    ]),

    setJobForCheck(id, status) {
      this.check.status = status;
      this.check.jobId = id;
    },

    checkJob(jobId, status) {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/job/check`,
          {
            mm_job_id: jobId,
            check: status,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$refs.closeUser.click();
          this.check.id = '';
          this.check.status = true;
          this.getMarketingEmployer();
        });
    },
    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },

    updateJobAd() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/job/update`,
          {
            mm_job_id: this.$route.params.job_id,
            job_title: this.marketingJobEdit.job_title,
            office: this.marketingJobEdit.office,
            city: this.marketingJobEdit.city.name
              ? this.marketingJobEdit.city.name
              : this.marketingJobEdit.city,
            country: this.marketingJobEdit.country.name
              ? this.marketingJobEdit.country.name
              : this.marketingJobEdit.country,
            postal_code: this.marketingJobEdit.postal_code,
            salary: this.marketingJobEdit.salary,
            linkedin: this.marketingJobEdit.linkedin,
            full_time: this.marketingJobEdit.full_time,
            workplace: this.marketingJobEdit.workplace,
            description: this.marketingJobEdit.description,
            url: this.marketingJobEdit.url,
            source_url: this.marketingJobEdit.source_url,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.isInGlobalEditMode = false;
          for (const key in this.editIconState) {
            this.editIconState[key] = false;
          }
          this.getMarketingEmployer();
          this.$toasted.success('Success', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {
          console.log(err);
        });
    },

    getMarketingEmployer() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/marketing/job/index/${this.$route.params.job_id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(res => {
          this.marketingJob = res.data;
          this.marketingJobEdit = JSON.parse(JSON.stringify(this.marketingJob));
          this.recruiters = res.data.hiring_team;
        })
        .catch(err => {
          console.log(err);
        });
    },

    convertTime(time) {
      const tz = this.getUserProfile.timezone;
      const userFormat = this.getUserProfile.format_date;

      const formatMap = {
        'YY-MM-DD': 'YY-MM-DD HH:mm',
        'YY/MM/DD': 'YY/MM/DD HH:mm',
        'DD-MM-YY': 'DD-MM-YY HH:mm',
        'DD/MM/YY': 'DD/MM/YY HH:mm',
        'MM-DD-YY': 'MM-DD-YY HH:mm',
        'MM/DD/YY': 'MM/DD/YY HH:mm',
      };

      const fmt = formatMap[userFormat] || 'YYYY-MM-DD';

      // Get the first date, add '12:00', then parse according to user format and timezone
      const selectedDate = time; // e.g. "24-06-25" if DD-MM-YY
      const dateWithTime = `${selectedDate} 12:00`;

      return moment.tz(dateWithTime, fmt, tz).format('YYYY-MM-DD');
    },
    resetModal() {
      this.professionId = '';
      this.professionName = '';
      this.$refs.closeAddProfession.click();
    },

    onShowAdJobModal() {
      this.retrieveEmployersDropdown();
      this.showModal = true;
    },
    removeHtmlTags(adText, ...args) {
      const removeAllDivTags = /<[/]{0,1}(div)[^><]*>/g;
      const removeInlineStyles = /style=["']?([a-zA-Z0-9 :\-#()._;',\s\n\r&]+);?["']?|<\s*font[^>]*>/g;

      return adText
        .replace(removeAllDivTags, '')
        .replace(removeInlineStyles, '')
        .replace(/<!--.*?-->/g, '')
        .replace(/\r?\n/g, '');
    },
    onEditText(desc) {
      this.selectedDescription = this.removeHtmlTags(desc, 'p');
      console.log(this.selectedDescription);
      this.editText = true;
    },
    getLocation(city, country) {
      if (city && country) {
        if (city.hasOwnProperty('name') && country.hasOwnProperty('name')) {
          return `${city.name}, ${country.name}`;
        }
      }
    },

    getEmploymentType(employment) {
      if (employment === 1) {
        return 'Employment';
      } else if (employment === 2) {
        return 'Self-employment';
      } else if (employment === 3) {
        return 'Employment / Self-Employment';
      }
    },
    onCancelUpdateForm() {
      this.isInGlobalEditMode = false;
      this.$refs.updateForm.reset();
    },
    clearCity() {
      this.marketingJobEdit.city = '';
    },
    showEditForm(e) {
      if (e.target.id === 'currency') {
        this.editIconState.currencyFormShow = !this.editIconState.currencyFormShow;
      }
      if (e.target.id === 'stFee') {
        this.editIconState.startingFeeFormShow = !this.editIconState.startingFeeFormShow;
      }
      if (e.target.id === 'rFee') {
        this.editIconState.recruitingFeeFormShow = !this.editIconState.recruitingFeeFormShow;
      }
      if (e.target.id === 'prFee') {
        this.editIconState.proggramingTestFormShow = !this.editIconState.proggramingTestFormShow;
      }
      if (e.target.id === 'devskiller') {
        this.editIconState.devskillerFormShow = !this.editIconState.devskillerFormShow;
      }
      if (e.target.id === 'anon') {
        this.editIconState.anonFormShow = !this.editIconState.anonFormShow;
      }
      if (e.target.id === 'workplace') {
        this.editIconState.workplaceFormShow = !this.editIconState.workplaceFormShow;
      }
      if (e.target.id === 'summary') {
        this.editIconState.summaryFormShow = !this.editIconState.summaryFormShow;
      }
      if (e.target.id === 'need-individuals') {
        this.editIconState.individualsFormShow = !this.editIconState.individualsFormShow;
      }
      if (e.target.id === 'duration') {
        this.editIconState.durationFormShow = !this.editIconState.durationFormShow;
      }
      if (e.target.id === 'fullTime') {
        this.editIconState.fullTimeFormShow = !this.editIconState.fullTimeFormShow;
      }
      if (e.target.id === 'employer') {
        this.editIconState.employerFormShow = !this.editIconState.employerFormShow;
      }
      if (e.target.id === 'city') {
        this.editIconState.cityFormShow = !this.editIconState.cityFormShow;
      }
      if (e.target.id === 'country') {
        this.editIconState.countryFormShow = !this.editIconState.countryFormShow;
      }
      if (e.target.id === 'street') {
        //  this.selectedAddress = this.getCandidateById.street;

        this.editIconState.streetFormShow = !this.editIconState.streetFormShow;
      }

      if (e.target.id === 'employment') {
        this.editIconState.employmentFormShow = !this.editIconState.employmentFormShow;
      }

      if (e.target.id === 'advertising-start-date') {
        this.editIconState.advertisingStartDateFormShow = !this.editIconState
          .advertisingStartDateFormShow;
      }
      if (e.target.id === 'approval-date') {
        this.editIconState.approvalDateFormShow = !this.editIconState.approvalDateFormShow;
      }
      if (e.target.id === 'advertising-end-date') {
        this.editIconState.advertisingEndDateFormShow = !this.editIconState
          .advertisingEndDateFormShow;
      }
      if (e.target.id === 'competences-required') {
        /*  this.selectedCompetences = this.getCandidateById.competences.map((c) => {
          return { ...c, id: c.competence_id };
        }); */

        this.editIconState.competencesRequiredFormShow = !this.editIconState
          .competencesRequiredFormShow;
      }
      if (e.target.id === 'competences-advantage') {
        /*  this.selectedCompetences = this.getCandidateById.competences.map((c) => {
          return { ...c, id: c.competence_id };
        }); */

        this.editIconState.competencesAdvantageFormShow = !this.editIconState
          .competencesAdvantageFormShow;
      }
      if (e.target.id === 'promoted') {
        this.editIconState.promotedFormShow = !this.editIconState.promotedFormShow;
      }
      if (e.target.id === 'created-by') {
        this.editIconState.createdByFormShow = !this.editIconState.createdByFormShow;
      }
      if (e.target.id === 'created-date') {
        this.editIconState.createdAtFormShow = !this.editIconState.createdAtFormShow;
      }
      if (e.target.id === 'lastUpdated') {
        this.editIconState.lastUpdatedFormShow = !this.editIconState.lastUpdatedFormShow;
      }
      if (e.target.id === 'years-of-experience') {
        this.editIconState.yearsOfExperianceFormShow = !this.editIconState
          .yearsOfExperianceFormShow;
      }
      if (e.target.id === 'degreeField') {
        this.editIconState.degreeFormShow = !this.editIconState.degreeFormShow;
      }
      if (e.target.id === 'degree-field') {
        this.editIconState.degreeFieldFormShow = !this.editIconState.degreeFieldFormShow;
      }
      if (e.target.id === 'languages') {
        this.editIconState.languagesFormShow = !this.editIconState.languagesFormShow;
      }
      if (e.target.id === 'postal') {
        this.editIconState.postalFormShow = !this.editIconState.postalFormShow;
      }
      if (e.target.id === 'relocation') {
        this.editIconState.relocationFormShow = !this.editIconState.relocationFormShow;
      }
    },
    handleSearchFilters() {
      /*  console.log(e); */
    },
    fetchCitiesByCountryId(e) {
      this.selectedCountry = e;

      this.retrieveCitiesListByCountryId({ id: this.selectedCountry.id });
    },
    removeJob() {
      axios
        .delete(
          `${process.env.VUE_APP_API_URL}/marketing/job/delete/${this.$route.params.job_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$refs.closeModalBtn.click();
          this.$router.push({ name: 'admin-marketing-jobs' });
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    onChangeJobStatus() {
      this.jobStatusModalShow = true;
    },
    onChangeJobServiceLevel() {
      this.jobSourcingModalShow = true;
    },
    saveNewJobStatus() {
      this.isLoading = true;

      this.setJobStatus({
        js_employer_jobad_id: this.$route.params.job_uuid,
        status: this.selectedJobStatus,
      })
        .then(() => {
          this.isLoading = false;
          this.jobStatusModalShow = false;

          this.$toasted.success(
            `Job Status changed from ${this.getJobStatusMixin(this.actualJobStatus).title} to ${
              this.getJobStatusMixin(this.selectedJobStatus).title
            }`,
            {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 10000,
            },
          );

          this.actualJobStatus = this.selectedJobStatus;
        })
        .catch(err => {
          this.$toasted.error(`${err}`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    onCancelSetJobStatus() {
      this.jobStatusModalShow = false;
      this.selectedJobStatus = this.actualJobStatus;
    },
    onCancelSetServiceLevel() {
      this.jobSourcingModalShow = false;
      this.selectedServiceLevel = this.actualServiceLevel;
    },
    forceRerender() {
      this.key += 1;
    },

    changeGlobalEditMode() {
      this.selectedCountry = this.getJobAdById.country;
      this.selectedCity = this.getJobAdById.city;
      this.selectedJobTitle = this.getJobAdById.title;
      this.selectedYearsExperience = this.getJobAdById.years_experience;
      this.selectedDegreeType = this.getJobAdById.degree_type;
      this.selectedDegreeField = this.getJobAdById.degree_field;
      this.selectedCompetences = this.getJobAdById.required_competences;
      this.selectedCompetencesAdvantage = this.getJobAdById.advantage_competences;
      this.selectedEmploymentType = this.getJobAdById.employment_type;
      this.selectedPromoted = this.getJobAdById.promoted;
      this.selectedPostalCode = this.getJobAdById.postal_code;
      this.selectedRelocation = this.getJobAdById.relocation;
      this.selectedIndividuals = this.getJobAdById.individuals_number;
      this.selectedFullTime = this.getJobAdById.full_time;
      this.selectedDuration = this.getJobAdById.duration;
      this.selectedSummary = this.getJobAdById.summary;
      this.selectedWorkplace = this.getJobAdById.workplace;
      this.selectedAnon = this.getJobAdById.anonymize;
      this.selectedTest.id = this.getJobAdById.devskiller_test_id;
      this.selectedTest.name = this.getJobAdById.devskiller_test_name;
      this.selectedStartingFee = this.getJobAdById.starting_fee;
      this.selectedRecruitingFee = this.getJobAdById.recruiting_fee;
      this.selectedProgrammingTestFe = this.getJobAdById.programming_test_fee;
      this.selectedCurrency = this.getJobAdById.currency;
      // this.selectedDescription = this.removeHtmlTags(this.getJobAdById.description, 'p');
      this.selectedDescription = this.getJobAdById.description;
      this.isInGlobalEditMode = !this.isInGlobalEditMode;
    },

    getMarketingEmployerRecruiters(id) {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/employers/getrecruiters`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: 10,
            date: 'all_time',
            js_profile_ids: [],
            mm_employer_id: id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.recruiters = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
  },

  computed: {
    ...mapGetters([
      'getAccType',
      'getJobAdById',
      'getUserProfile',
      'getAllCountries',
      'getJobAdCommentsList',
      'getCitiesListByCountry',
      'getActivitiesForJob',
      'getLanguagesList',
      'getCompetencesFilterList',
    ]),

    dateTimeFormat() {
      // assume getUserProfile.format_date is something like "MM-dd-yyyy"
      return `${this.getUserProfile.format_date} HH:mm`;
      // or for 12-hour clock with AM/PM:
      // return `${this.getUserProfile.format_date} hh:mm a`
    },
  },
  updated() {
    this.jobAdData = this.getJobAdById;
  },
  mounted() {
    this.getMarketingEmployer();
    this.retrieveUserProfile().then(() => {});
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.jobshark-header {
  font-size: 16px;
  font-weight: 700;
  border-bottom: 1px solid #ddd;
  margin: 30px 0 25px 0;
  padding-bottom: 12px;
}
.advertising {
  font-family: $font-family-sans-lato;
  padding: 40px 20px;
  .form-group {
    margin-bottom: 20px;
    label {
      font-size: 14px;
      font-weight: 700;
    }
  }
  .view-link {
    .btn-outline {
      color: red;
      width: 31px;
      height: 31px;
      &:first-of-type {
        color: green;
      }
    }
    &:hover {
      .show {
        opacity: 1 !important;
      }
    }
  }
}

.header-contacts {
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    font-size: 18px;
    margin-bottom: 6px;
  }
}

.badge {
  background: mix($color-white, $btn-default-color, 50);
  color: #fff;
  margin-left: 5px;
  text-align: center;
  animation: pulse 2s infinite;
  animation-duration: pulse 10s;
  -webkit-animation-duration: 5s;
}

@keyframes pulse {
  0% {
  }
  50% {
    -moz-box-shadow: 0 0 0 0 $color-orange;
    box-shadow: 0 0 0 0 $color-orange;
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

.ql-snow {
  min-height: 580px;
}
.job-details {
  .edit-fields {
    width: 100%;
    padding-left: 15px;
  }
  span.edit-label {
    font-weight: 700;
    padding-top: 10px;
    width: 150px;
    flex-shrink: 0;
    &.last {
      width: 75px;
    }
  }
}

.job-details-description {
  li {
    span {
      width: 170px;
    }
    div {
      flex: 1;
    }
    .icon-container {
      flex: 0;
      min-width: 120px;
      padding: 0 20px;
    }
  }
}

.job-edit {
  &-icon {
    fill: #a3a6b4;
    margin-top: -5px;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.custom-card {
  overflow: hidden;
}

.job-content {
  overflow: auto;
}

#description {
  padding: 0 24px;
}
.card {
  margin: 0;
}

.job-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  li {
    position: relative;
  }

  .icon-container {
    position: relative;
    padding-left: 20px;
  }

  li span {
    display: inline-block;
    font-weight: 700;
    &.icon-container {
      position: relative;
    }
  }
  .empl-icon {
    position: absolute;
    display: inline-block;
    top: 50%;
    transform: translate(0, -50%);
    left: -45px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #ddd;
      border-radius: 50%;
    }
  }

  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  overflow: hidden;

  .row {
    margin: 0;
  }

  li.list-group-item {
    padding-left: 0 !important;
    border: none !important;
    padding-right: 0;
    b {
      font-weight: 600 !important;
    }
  }

  li > .d-flex {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    margin: 3px 12px;
    padding: 12px 0;
    height: 46px;
    flex: 1;
    align-items: center;
  }

  li span {
    min-width: 110px !important;

    white-space: nowrap;
  }

  li > span:not(:nth-child(2n + 0)) {
    font-weight: 700;
    min-width: 19rem;
  }

  .popup {
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    position: absolute;
    padding: 8px 12px 6px 12px !important;
    top: 75%;
    left: -15px;
    width: 100%;
    height: auto !important;
    z-index: 9;
    flex-wrap: wrap;
  }

  .tech-icons {
    width: 100%;
    position: relative;
    margin-top: -20px;
    .icon-container {
      min-width: 100px;
      text-align: center;
      display: inline-block;
      &:first-of-type {
        pointer-events: none;
        padding-left: 0 !important;
        margin-left: -30px;
      }
      .icon-wrapper {
        img {
          width: 25px;
          height: 25px;
          display: block;
          margin: 0 auto;
        }
      }
    }
    .btn-secondary {
      background: none !important;
      border: none !important;
      box-shadow: none !important;
      position: absolute;
      top: 13px;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .dropdown-menu {
      width: 100%;
      border-radius: 0;
      .list-inline {
        li {
          margin: 0;
          text-align: center;
          width: 25%;
        }
      }
    }
    .dropdown-toggle {
      &:after {
        display: none;
      }
    }
  }

  .edit-btn {
    position: absolute;
    left: 0;
    .edit-icon {
      color: #666;
    }
  }
}

/deep/ .description-text {
  h6 {
    font-size: 1.125rem;
    font-weight: 700;
  }

  &-body {
    font-size: 0.875rem;
    font-family: $font-family-sans-lato;
  }
}

/* Title Header */
.job-edit {
  &-icon {
    fill: #a3a6b4;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.header-title {
  width: 100%;
  padding: 25px 0 5px 6px;

  &-name {
    font: 21px Montserrat;
    letter-spacing: 0;
    color: #000;
    flex: 1;
  }
  .single-job-controls {
    margin-left: 6px;
  }

  .name-edit {
    flex-shrink: 0;
  }
}

.list-group-item {
  border: none;
  border-bottom: 1px solid #ddd;
  padding-left: 0;

  .btn {
    background-color: #fff;
    border: 1px solid rgba(60, 60, 60, 0.26) !important;
    width: 24px;
    height: 24px;
    margin-left: 5px;
    font-size: 12px;
    flex-shrink: 0;
    border-radius: 5px;
    padding: 0;
    align-items: center;
    justify-content: center;
    text-align: center;
    .fa-check {
      color: green;
    }
    .fa-times {
      color: Red;
    }
  }
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin-top: 26px !important;
  }
  .job-aside-activity {
    display: none !important;
  }
  .desktop-pipelines {
    padding: 0 23px;
  }
}

@media only screen and (max-width: 992px) {
  .mobile-clear {
    padding: 0 17px;
  }
  #description {
    .container {
      max-width: 100%;
    }
    .col-md-8 {
      display: block;
      flex: 100%;
      width: 100% !important;
      max-width: 100%;
    }
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      .tab-content {
        margin: 0 !important;
      }
    }
    .description-scroll {
      max-height: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}

@media only screen and (max-width: 768px) {
  #description {
    .job-details {
      .list-group-item {
        padding-left: 0 !important;
      }
    }
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      padding-bottom: 12px;
      .container {
        max-width: 100%;
      }
      .tab-content {
        margin: 0 !important;
      }
    }
    .description-scroll {
      max-height: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}

@media only screen and (max-width: 576px) {
  .header-title {
    width: 100%;
    padding: 25px 0 5px 6px;

    &-name {
      font: 18px Montserrat;
      letter-spacing: 0;
      color: #000;
      flex: 1;
    }
    .single-job-controls {
      margin-left: 6px;
    }

    .name-edit {
      flex-shrink: 0;
    }
  }

  #description {
    padding: 0;
    overflow: hidden;
    .card {
      margin: 0 !important;
      min-height: auto;
      height: auto !important;
      padding-bottom: 70px;
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
      .req {
        min-height: 100vh;
      }
    }
    .tab-content {
      margin: 0;
    }
    .description-scroll {
      max-height: none;
    }
    .single-job-controls {
      margin-top: 20px;
      .select-style {
        position: relative;
        left: 0;
        max-width: 75%;
      }
      button {
        margin-left: auto !important;
      }
    }
    .mobile-only {
      display: block !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .comments {
    padding: 8px;
  }
  .req-mobile {
    margin-top: 31px !important;
  }
}

.tech-icons {
  margin-top: -30px;
  img {
    width: 30px;
    height: auto;
  }
}

.job-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  margin-top: 15px;

  li {
    display: inline-flex;

    .item-title {
      white-space: nowrap;
      font-weight: 700;
      margin-right: 20px;
    }

    .item-body {
    }
    &:nth-of-type(4) {
      .item-body {
        .tech-icons {
          margin-top: 0;
        }
      }
    }
  }
  .candidate-tag {
    border: 1px solid #a3a6b4;
    border-radius: 20px;
    color: #a3a6b4;
    padding: 6px 10px;
  }

  .candidate-tag-selected {
    color: $color-orange;
    border: 1px solid $color-orange;
  }

  .list-group {
    padding-left: 5px;
  }
  .tech-icons {
    position: relative;
    .show-more-icons {
      position: absolute;
      top: 123%;
      left: -5px;
      width: auto;
      max-width: 100%;
      background: #fff;
      border: 1px solid #ddd;
      z-index: 9;
      flex-wrap: wrap;
      .d-flex {
        padding: 12px 6px 6px 10px;
      }
      .icon-container {
        margin-right: 23px;
      }
    }
    .show-more-icons.second {
      left: -14px;
    }
    .collapsing {
      -webkit-transition: unset !important;
      transition: unset !important;
    }
  }
  .job-details {
    li {
      padding-left: 12px;
    }
  }
  /* Resetting utility class */
  .description-text {
    padding: 0 !important;
  }
}
</style>
